module.exports = __webpack_public_path__ + "assets/img/822c3341fd8aed0f237ac6aa59e059a3.svg";